/**
 * @generated SignedSource<<defe31398c4a6e2d62209b09fb10d372>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ForumTopicCreatePageQuery$variables = {
  slug: string;
};
export type ForumTopicCreatePageQuery$data = {
  readonly forumBySlug: {
    readonly guidelines: string | null | undefined;
    readonly id: string;
    readonly slug: string;
  } | null | undefined;
};
export type ForumTopicCreatePageQuery = {
  response: ForumTopicCreatePageQuery$data;
  variables: ForumTopicCreatePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Forum",
    "kind": "LinkedField",
    "name": "forumBySlug",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "guidelines",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForumTopicCreatePageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForumTopicCreatePageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3cf1b2fbbb15c2a7acb1431b1cfb824b",
    "id": null,
    "metadata": {},
    "name": "ForumTopicCreatePageQuery",
    "operationKind": "query",
    "text": "query ForumTopicCreatePageQuery(\n  $slug: String!\n) {\n  forumBySlug(slug: $slug) {\n    id\n    slug\n    guidelines\n  }\n}\n"
  }
};
})();

(node as any).hash = "678211f555907f3c68928d27394d20dc";

export default node;
